module.exports = __webpack_public_path__ + "img/banner.4125cb74.jpg";